import { ICenterAddress } from ".";

export interface ICenterBase {
    id: number,
    alias: string,
    name: string,
    isMemberCenter: boolean,
    isUtilizing3gKidneyForLife?: boolean,
    hasPairs?: boolean,
    isLiverParticipant?: boolean,
    isAdvReimburseEnabled?: boolean,
    referDonorToNkr?: boolean,
    centerAddresses: ICenterAddress[]
}

export interface ICenterByDistance {
    id: number,
    alias: string,
    isMicrositeParticipant: boolean,
    distanceInMiles: number
}